export const BASE_VIDEO_URL = "https://emsbt.com/hls/play.m3u8?&time=0&profile=360p&source=";
export const BASE_HLS_URL = "https://emsbt.com";